import { Box, styled } from '@mui/material';

export const GridContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: 0, // No gap between columns
  gridTemplateAreas: '"list content"',
  gridTemplateColumns: 'clamp(250px, 14vw, 280px) 1fr', // Wider sidebar for monitors (xl)
  gridTemplateRows: '1fr',
  width: 'clamp(1200px, 95vw, 2000px)',
  maxWidth: 'clamp(1800px, 98vw, 2400px)', // Scalable max width
  height: 'clamp(58vh, 68vh, 85vh)', // Fully scalable height
  minHeight: 0,
  overflow: 'hidden',
  margin: '0 auto',
  marginTop: 0,
  marginBottom: 0,
  [theme.breakpoints.up('xl')]: {
    height: 'clamp(64vh, 74vh, 80vh)', // Taller on monitors
    maxHeight: '1050px', // Cap height on very large monitors
  },
  [theme.breakpoints.down('xl')]: {
    gridTemplateColumns: 'clamp(200px, 12vw, 230px) 1fr', // Wider sidebar for laptops
  },
  [theme.breakpoints.down('lg')]: {
    width: 'clamp(1100px, 98vw, 1882px)',
    gridTemplateColumns: 'clamp(150px, 9vw, 180px) 1fr', // Wider sidebar on medium screens
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'clamp(200px, 20vw, 300px) 1fr', // Much wider sidebar on small screens
  },
}));
